// Presentation state only; the existing server remains authoritative for requests.
const normalize = value => String(value || '').trim().toLocaleLowerCase('tr-TR');
const storageKey = owner => `kelimo-social-seen-r11:${normalize(owner)}`;
function readSeen(storage, owner) {
  try { const keys = JSON.parse(storage.getItem(storageKey(owner))); return new Set(Array.isArray(keys) ? keys.filter(k => typeof k === 'string').slice(-200) : []); }
  catch (_) { return new Set(); }
}
function writeSeen(storage, owner, seen) {
  try { storage.setItem(storageKey(owner), JSON.stringify([...seen].slice(-200))); } catch (_) { /* In-memory deduplication still works. */ }
}
function reconcileSocialAlert(previous, snapshot, owner, seen = new Set()) {
  const names = snapshot.playerDisplayNames || {}, notices = snapshot.notices || [];
  const blocked = new Set(snapshot.blocked || []), friends = new Set(snapshot.friends || []);
  const requests = (snapshot.incoming || []).filter(r => !blocked.has(r.from)).map(r => {
    const notice = notices.find(n => n.kind === 'friend-request' && n.from === r.from && Number(n.createdAt) >= Number(r.createdAt));
    return {key: `request:${r.from}:${r.createdAt || notice?.id || 'legacy'}`, from: r.from, name: names[r.from] || r.from, read: Boolean(notice?.read)};
  }).filter(r => !r.read);
  const accepted = notices.filter(n => n.kind === 'friend-accepted' && !n.read && friends.has(n.from) && !blocked.has(n.from)).map(n => ({key: `notice:${n.id}`, from: n.from, name: names[n.from] || n.from}));
  const sameOwner = previous?.owner === owner;
  const freshRequests = requests.filter(r => !seen.has(r.key));
  const keep = (items, old) => items.filter(item => !seen.has(item.key) || (sameOwner && old?.some(value => value.key === item.key)));
  const pending = keep(requests, previous?.requests), completed = keep(accepted, previous?.accepted);
  const nextSeen = new Set(seen);
  for (const item of [...requests, ...accepted]) nextSeen.add(item.key);
  while (nextSeen.size > 200) nextSeen.delete(nextSeen.values().next().value);
  return {alert: pending.length || completed.length ? {owner, requests: pending, accepted: completed} : null, seen: nextSeen, freshRequests: freshRequests.length};
}
function resolveSocialAlert(alert, action, target) {
  if (!alert || !['accept', 'reject', 'block', 'remove'].includes(action)) return alert;
  const requests = alert.requests.filter(item => item.from !== target);
  const accepted = ['block','remove'].includes(action) ? alert.accepted.filter(item => item.from !== target) : alert.accepted;
  return requests.length || accepted.length ? Object.assign({}, alert, {requests, accepted}) : null;
}
module.exports = {readSeen, writeSeen, reconcileSocialAlert, resolveSocialAlert};
